/* === TDM ARTICLE CONTENT ===
   Hydrates inline product components inside a blog article body:
   - old placeholder swap: [tdm-product-grid-placeholder] -> pre-rendered slider
   - product link auto-upgrade: tdm-inline-product-card[data-handle] and any
     plain product link typed in the article text become a visual mention
     card (image + title + price + add to cart), via a fetch to the Storefront
     product JSON endpoint.
   Pairs with tdm-article-content.css and sections/main-article.liquid. */

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.tdm-product-grid-placeholder[data-products]').forEach(function (placeholder) {
    var handles = placeholder.dataset.products.trim();
    var slider = document.querySelector('.tdm-inline-slider-wrapper[data-handles="' + handles + '"]');
    if (slider) {
      slider.style.display = '';
      placeholder.replaceWith(slider);
    }
  });
});

function tdmBuildMentionCard(p) {
  var v = p.variants.find(function (v) { return v.available; }) || p.variants[0];
  var img = p.images && p.images[0] ? 'https:' + p.images[0] : '';
  var price = (v.price / 100).toFixed(2) + ' €';
  var productUrl = '/products/' + p.handle;

  var card = document.createElement('span');
  card.className = 'tdm-product-mention-card';
  card.innerHTML = `
    <a href="${productUrl}" class="tdm-product-mention-card__link">
      <img src="${img}" alt="${p.title}">
      <span class="tdm-product-mention-card__info">
        <span class="tdm-product-mention-card__title">${p.title}</span>
        <span class="tdm-product-mention-card__price">· ${price}</span>
      </span>
    </a>
    <a href="/cart/${v.id}:1" class="tdm-product-mention-card__atc-icon" aria-label="Ajouter au panier">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>
        <line x1="3" y1="6" x2="21" y2="6"/>
        <path d="M16 10a4 4 0 01-8 0"/>
      </svg>
    </a>
  `;
  return card;
}

function tdmGetProductHandle(href) {
  try {
    var url = new URL(href, window.location.origin);
    var match = url.pathname.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  } catch (e) {
    return null;
  }
}

function tdmHydrateMention(el, handle) {
  if (!handle) return;
  fetch('/products/' + handle + '.js')
    .then(function (r) { return r.json(); })
    .then(function (p) { el.replaceWith(tdmBuildMentionCard(p)); })
    .catch(function () {});
}

document.querySelectorAll('.tdm-inline-product-card[data-handle]').forEach(function (span) {
  tdmHydrateMention(span, span.dataset.handle.trim());
});

// Exclut les liens déjà produits par nos propres composants (slider, tableau
// routine, cartes mention rendues côté serveur), les CTA stylés à la main
// (un style inline = un bouton éditorial volontaire, pas une mention à
// enrichir) et tout lien marqué explicitement "tdm-no-mention" : seuls les
// liens produit tapés "à nu" dans le texte doivent être auto-transformés.
document.querySelectorAll('.article-template__content a[href*="/products/"]').forEach(function (link) {
  if (link.closest('.tdm-inline-slider-wrapper, .tdm-routine-table, .tdm-product-mention-card')) return;
  if (link.hasAttribute('style') || link.classList.contains('tdm-no-mention')) return;
  tdmHydrateMention(link, tdmGetProductHandle(link.getAttribute('href')));
});
